import { strings } from "@/I18n";
import { cn } from "@/lib/utils";
import {
  formatStatusText,
  getBatteryDotColor,
  getBatteryTextColor,
  getBooleanDotColor,
  getBooleanTextColor,
  getDockTypeDotColor,
  getDockTypeTextColor,
  getLockStatusDotColor,
  getLockStatusTextColor,
  getParticularsDotColor,
  getParticularsTextColor,
  getStatusDotColor,
  getStatusTextColor,
  getTransactionTypeDotColor,
  getTransactionTypeTextColor,
  getTypeDotColor,
  getTypeTextColor,
} from "@/utils/statusColors";

type StatusVariant =
  | "default"
  | "battery"
  | "lock"
  | "transactionType"
  | "boolean"
  | "dockType"
  | "type"
  | "particulars";

interface StatusBadgeProps {
  status: string | number | boolean | null | undefined;
  variant?: StatusVariant;
  className?: string;
}

export function StatusBadge({
  status,
  variant = "default",
  className = "",
}: StatusBadgeProps) {
  let dotColor: string;
  let textColor: string;
  let displayText: string;

  switch (variant) {
    case "battery":
      dotColor = getBatteryDotColor(status as number);
      textColor = getBatteryTextColor(status as number);
      displayText =
        status != null ? `${status}%` : strings("common.notAvailable");
      break;

    case "lock":
      dotColor = getLockStatusDotColor(status as boolean);
      textColor = getLockStatusTextColor(status as boolean);
      displayText =
        status === true
          ? strings("common.open")
          : status === false
            ? strings("common.closed")
            : strings("common.notAvailable");
      break;

    case "transactionType":
      dotColor = getTransactionTypeDotColor(status as string);
      textColor = getTransactionTypeTextColor(status as string);
      displayText = formatStatusText(status as string);
      break;

    case "boolean":
      dotColor = getBooleanDotColor(status as boolean);
      textColor = getBooleanTextColor(status as boolean);
      displayText =
        status === true
          ? strings("common.yes")
          : status === false
            ? strings("common.no")
            : strings("common.notAvailable");
      break;

    case "dockType":
      dotColor = getDockTypeDotColor(status as string);
      textColor = getDockTypeTextColor(status as string);
      displayText = formatStatusText(status as string);
      break;

    case "type":
      dotColor = getTypeDotColor(status as string);
      textColor = getTypeTextColor(status as string);
      displayText = formatStatusText(status as string);
      break;

    case "particulars":
      dotColor = getParticularsDotColor(status as string);
      textColor = getParticularsTextColor(status as string);
      displayText = formatStatusText(status as string);
      break;

    case "default":
    default:
      dotColor = getStatusDotColor(status as string);
      textColor = getStatusTextColor(status as string);
      displayText = formatStatusText(status as string);
      break;
  }

  return (
    <span className={cn("tw-flex tw-items-center tw-gap-2", className)}>
      <span
        className={cn(
          "tw-w-2 tw-h-2 tw-rounded-full tw-flex-shrink-0",
          dotColor
        )}
      />
      <span className={cn("tw-truncate", textColor)}>{displayText}</span>
    </span>
  );
}
